export enum InputType {
  TEXT = 0,
  TEXT_AREA = 1,
  CURRENCY = 2, // not implemented yet
  SWITCH = 3,  // not implemented yet
  DATE = 4,
  PHONE = 5,
  STATE = 6,
  ZIP = 7,
  CUSTOM = 999
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/componentsReusable/InputType.ts